import React, { useState } from 'react';
import { Sheet } from './Sheet';
import { Button } from './Button';

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  /** 押したあとに何が起きるかを1文で */
  body?: React.ReactNode;
  confirmText: string;
  danger?: boolean;
  onConfirm: () => Promise<unknown> | void;
}

/** 消す・作り直すなど、取り消せない操作の前に出す確認。押したら終わるまで閉じない。 */
export const ConfirmSheet: React.FC<Props> = ({ open, onClose, title, body, confirmText, danger, onConfirm }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      await onConfirm();
      onClose();
    } catch {
      // 失敗の知らせは呼び出し側が出す。板は開いたままにして、もう一度押せるようにする
    } finally {
      setBusy(false);
    }
  };
  return (
    <Sheet open={open} onClose={() => !busy && onClose()} title={title}>
      <div className="v2-stack">
        {body && <p className="v2-muted">{body}</p>}
        <div className="v2-row-gap" style={{ justifyContent: 'flex-end' }}>
          <Button variant="ghost" onClick={onClose} disabled={busy}>
            やめる
          </Button>
          <Button variant={danger ? 'danger' : 'primary'} loading={busy} onClick={run}>
            {confirmText}
          </Button>
        </div>
      </div>
    </Sheet>
  );
};
